// ============================================================
// FORGEIQ — ENGINEERING RULES ENGINE v2.1
// All 6 machines · 8 templates · 11 materials
// Sturdfix / Singhania International, Ludhiana
// ============================================================

export const MACHINES: Record<string, any> = {
  SJBF_63S:  { id:'SJBF_63S',  name:'Sijin 63S',    type:'BOLT', stations:3, force_kg:38000,  wire_min:3,  wire_max:6,    shank_max:65,  qty:2 },
  SJBF_64S:  { id:'SJBF_64S',  name:'SJBF-64S',     type:'BOLT', stations:4, force_kg:40000,  wire_min:3,  wire_max:6,    shank_max:75,  qty:2 },
  DBF_84S:   { id:'DBF_84S',   name:'DBF-84S',       type:'BOLT', stations:4, force_kg:60000,  wire_min:5,  wire_max:8,    shank_max:90,  qty:2 },
  SJBF_134L: { id:'SJBF_134L', name:'SJBF-134L',     type:'BOLT', stations:4, force_kg:120000, wire_min:8,  wire_max:12.7, shank_max:152, qty:2,
    die_case_od:86.0, die_len:190, ko_pin_len:215, punch_case_od:60.0, punch_case_len:130, cbf:'CBF-04,05',
    ko_head_od:25.0, ko_head_mat:'EN-24', ko_pin_mat:'M2', die_mat:'H13', conc_tir:0.02 },
  DBF_134L:  { id:'DBF_134L',  name:'DBF-134L',      type:'BOLT', stations:4, force_kg:120000, wire_min:8,  wire_max:12.7, shank_max:160, qty:1,
    die_case_od:86.0, die_len:190, ko_pin_len:215, punch_case_od:60.0, punch_case_len:130 },
  SJBF_164S: { id:'SJBF_164S', name:'SJBF-164S',     type:'BOLT', stations:4, force_kg:210000, wire_min:10, wire_max:16,   shank_max:152, qty:1,
    die_case_od:90.0, die_len:190, ko_pin_len:215, punch_case_od:74.98, punch_case_len:185, cbf:'CBF-03',
    stripper_bush_od:39.98, hex_holder_od:44.98, ko_pin_mat:'M2', die_mat:'H13' },
  SN_11B6S:  { id:'SN_11B6S',  name:'11B6S',         type:'NUT',  stations:6, force_kg:55000,  wire_min:3,  wire_max:6,    qty:2,
    nut_size:'M3–M6', af_min:5.5, af_max:12.7, ko_pin_len:85, punch_len:60, punch_working:25, die_h:22, die_taper:6, finger_len:35, finger_body_od:10.18, tail_taper:20, finger_w:5 },
  SN_14B6S:  { id:'SN_14B6S',  name:'14B6S',         type:'NUT',  stations:6, force_kg:85000,  wire_min:6,  wire_max:10,   qty:2,
    nut_size:'M6–M10', af_min:10, af_max:17, ko_pin_len:110, punch_len:70, punch_working:25, die_h:25, die_taper:5, finger_len:81, finger_body_od:12.85, tail_taper:20, finger_w:9, finger_t:2.5 },
  SN_19B6S:  { id:'SN_19B6S',  name:'19B6S',         type:'NUT',  stations:6, force_kg:130000, wire_min:8,  wire_max:14,   qty:2,
    nut_size:'M8–M14', af_min:14, af_max:22, ko_pin_len:130, punch_len:85, punch_working:25, die_h:22, die_taper:5, finger_len:100, finger_body_od:16.875, tail_taper:20, finger_w:10, finger_t:8 },
  SN_24B6S:  { id:'SN_24B6S',  name:'24B6S',         type:'NUT',  stations:6, force_kg:220000, wire_min:10, wire_max:18,   qty:1,
    nut_size:'M10–M18', af_min:17, af_max:26, ko_pin_len:170, punch_len:105, punch_working:20, die_h:27, die_taper:5, finger_len:120, finger_body_od:14.0, tail_taper:20, finger_w:15, finger_t:2 },
};

export const MATERIALS: Record<string, any> = {
  '10B30': { name:'10B30 Boron', grade:'10.9', sigma0:450, K:1050, n:0.19, ht_q:'~870', ht_t:'per spec', hrc:'32–39', app:'High-strength bolts' },
  '10B33': { name:'10B33 Boron', grade:'10.9', sigma0:480, K:1100, n:0.18, app:'High-strength bolts' },
  '10B21': { name:'10B21',       grade:'10.9', sigma0:380, K:900,  n:0.21, app:'Bolts, more ductile' },
  '15B25': { name:'15B25 Boron', grade:'8.8',  sigma0:280, K:720,  n:0.23, ht_q:'870–880', ht_t:'450–530', hrc:'23–32', app:'Grade 8.8 hex bolts' },
  'SAE1008':{ name:'SAE 1008',   grade:'5.8',  sigma0:180, K:560,  n:0.26, app:'Drain plugs, low strength' },
  'SAE1010':{ name:'SAE 1010',   grade:'5.8',  sigma0:200, K:580,  n:0.25, app:'General Grade 5.8' },
  'SAE1022':{ name:'SAE 1022',   grade:'8.8',  sigma0:320, K:780,  n:0.22, app:'Medium strength' },
  'SAE1035':{ name:'SAE 1035',   grade:'8.8',  sigma0:380, K:850,  n:0.20, app:'Medium-high strength' },
  'SCM435': { name:'SCM-435',    grade:'—',    sigma0:520, K:1150, n:0.17, ht_q:'870–880', ht_t:'≥390', hrc:'45–49', app:'Set screws, Cr-Mo' },
  'EN8D':   { name:'EN8D (1045)',grade:'—',    sigma0:350, K:850,  n:0.22, hrc:'27–32', app:'Heavy hex nuts' },
  'A194_2H':{ name:'A194 Gr 2H', grade:'—',   sigma0:400, K:920,  n:0.20, app:'High-pressure stud nuts' },
};

export const TEMPLATES: Record<string, any> = {
  A:    { name:'Long bolt',              family:'BOLT', stations:4, trigger:'L/D > 4.0, has shank' },
  A_EXT:{ name:'Long bolt (ext hex)',    family:'BOLT', stations:4, trigger:'L/D > 4.0, external hex head' },
  B:    { name:'Short flange / plug',    family:'BOLT', stations:4, trigger:'L/D < 3.5, flange or plug' },
  B_S:  { name:'Short flange + serration',family:'BOLT',stations:4, trigger:'L/D < 3.5, has serration' },
  C:    { name:'Headless set screw',     family:'BOLT', stations:2, trigger:'head_type = NONE, hex socket' },
  D1:   { name:'Serrated flange nut',    family:'NUT',  stations:6, trigger:'has_flange + has_serration' },
  D2:   { name:'Plain hex nut',          family:'NUT',  stations:6, trigger:'plain hex, hex at Stn 2' },
  D3:   { name:'Nylock nut',             family:'NUT',  stations:6, trigger:'has_nylon_insert' },
  D4:   { name:'Heavy hex nut',          family:'NUT',  stations:6, trigger:'ASME B18.2.2, EN8D' },
  D5:   { name:'Conical washer nut',     family:'NUT',  stations:6, trigger:'has_conical_washer' },
  D6:   { name:'Spinning / socket nut',  family:'NUT',  stations:6, trigger:'has_socket_feature' },
};

export interface PartInput {
  part_type: 'BOLT' | 'NUT';
  nominal_diameter_mm: number;
  thread_pitch_mm: number;
  total_length_mm: number;
  shank_length_mm?: number;
  head_type?: string;
  socket_type?: string;
  has_flange?: boolean;
  has_serration?: boolean;
  has_nylon_insert?: boolean;
  has_conical_washer?: boolean;
  nut_height_mm?: number;
  nut_af_mm?: number;
  wire_diameter_mm?: number;
  blank_length_mm?: number;
  weight_grams?: number;
  material_id?: string;
  thread_system?: string;
}

export function selectTemplate(part: PartInput): { template: string; confidence: number; reasoning: string[] } {
  const r: string[] = [];
  if (part.part_type === 'NUT') {
    if (part.has_nylon_insert) { r.push('Nylon insert → D3'); return { template:'D3', confidence:0.95, reasoning:r }; }
    if (part.has_conical_washer) { r.push('Conical washer → D5'); return { template:'D5', confidence:0.95, reasoning:r }; }
    if (part.has_flange && part.has_serration) { r.push('Flange + serration → D1'); return { template:'D1', confidence:0.95, reasoning:r }; }
    r.push('Plain hex nut → D2 (hex forms Stn 2)'); return { template:'D2', confidence:0.92, reasoning:r };
  }
  if (part.head_type === 'NONE' && part.socket_type === 'HEX_SOCKET') {
    r.push('No head + hex socket → Template C (set screw, 2 stations)');
    return { template:'C', confidence:0.98, reasoning:r };
  }
  const wire = part.wire_diameter_mm ?? part.nominal_diameter_mm * 1.05;
  const blank = part.blank_length_mm ?? part.total_length_mm * 1.02;
  const ld = blank / wire;
  r.push(`L/D = ${ld.toFixed(2)} (blank ${blank.toFixed(1)} / wire Ø${wire.toFixed(2)})`);
  if (ld > 4.0) {
    const t = part.head_type === 'EXTERNAL_HEX' ? 'A_EXT' : 'A';
    r.push(`L/D > 4.0 → Template ${t} (long bolt, 4 stations)`);
    return { template:t, confidence:0.92, reasoning:r };
  }
  if (ld < 3.5) {
    const t = part.has_serration ? 'B_S' : 'B';
    r.push(`L/D < 3.5 → Template ${t} (short flange, 4 stations)`);
    return { template:t, confidence: part.has_serration ? 0.95 : 0.90, reasoning:r };
  }
  r.push(`L/D ${ld.toFixed(2)} borderline 3.5–4.0 → Template A (engineer review advised)`);
  return { template:'A', confidence:0.65, reasoning:r };
}

export function matchMachines(part: PartInput, template: string) {
  const wire = part.wire_diameter_mm ?? part.nominal_diameter_mm * 1.05;
  const blank = part.blank_length_mm ?? part.total_length_mm * 1.02;
  const isNut = part.part_type === 'NUT';
  const mat = MATERIALS[part.material_id ?? 'SAE1010'];
  const sigma_f = mat.K * Math.pow(0.5, mat.n);
  const d_head = isNut ? (part.nut_af_mm ?? part.nominal_diameter_mm * 1.7) : part.nominal_diameter_mm * 1.7;
  const h_head = isNut ? (part.nut_height_mm ?? part.nominal_diameter_mm * 0.8) : part.nominal_diameter_mm * 0.65;
  const A_head = Math.PI / 4 * d_head * d_head;
  const F_est_kg = sigma_f * A_head * (1 + 0.17 * d_head / h_head) / 9.81;

  return Object.values(MACHINES).map((m: any) => {
    const blockers: string[] = [];
    if (isNut && m.type !== 'NUT') blockers.push('Not a nut former');
    if (!isNut && m.type !== 'BOLT') blockers.push('Not a bolt former');
    if (m.type === m.type) {
      if (wire < m.wire_min) blockers.push(`Wire Ø${wire.toFixed(1)} < min Ø${m.wire_min}`);
      if (wire > m.wire_max) blockers.push(`Wire Ø${wire.toFixed(1)} > max Ø${m.wire_max}`);
      if (!isNut && blank > (m.shank_max ?? 999)) blockers.push(`Blank ${blank.toFixed(0)}mm > max ${m.shank_max}mm`);
      if (isNut && m.af_min) {
        const af = part.nut_af_mm ?? part.nominal_diameter_mm * 1.7;
        if (af < m.af_min) blockers.push(`A/F ${af} < min ${m.af_min}`);
        if (af > m.af_max) blockers.push(`A/F ${af} > max ${m.af_max}`);
      }
    }
    const util = F_est_kg / (m.force_kg * 0.85) * 100;
    if (util > 100) blockers.push(`Force ${(F_est_kg/1000).toFixed(0)}t > 85% capacity`);
    const eligible = blockers.filter(b => !b.startsWith('Not a')).length === 0 && (isNut ? m.type === 'NUT' : m.type === 'BOLT');
    return { machine_id: m.id, name: m.name, type: m.type, eligible, blockers, util: Math.round(util), force_kg: m.force_kg };
  }).sort((a, b) => (b.eligible ? 1 : 0) - (a.eligible ? 1 : 0) || a.util - b.util);
}

export function processFlow(part: PartInput, template: string, machineName: string): string[] {
  const mat = MATERIALS[part.material_id ?? 'SAE1010'];
  const steps = [`Raw Material — ${part.material_id ?? '—'} · Wire Ø${(part.wire_diameter_mm ?? part.nominal_diameter_mm * 1.05).toFixed(2)}mm · Drawn condition`];
  steps.push(`Cold Forging — ${machineName} — In House`);
  if (template === 'C') {
    steps.push(`Heat Treatment — Q${mat.ht_q ?? '870'}°C · T${mat.ht_t ?? '≥390'}°C · ${mat.hrc ?? '45–49'} HRC — Outsource`);
    steps.push('Threading — Circular Rolling — In House');
    steps.push('Surface Treatment — Manganese Phosphate + RPO');
  } else if (['A','A_EXT','B','B_S'].includes(template)) {
    if (mat.ht_q) steps.push(`Heat Treatment — Q${mat.ht_q}°C · T${mat.ht_t}°C · ${mat.hrc} HRC — Outsource`);
    steps.push('Threading — Flat Rolling — In House');
    steps.push('Surface Treatment — as specified');
  } else {
    steps.push('Tapping — In House');
    steps.push('Surface Treatment — Zinc / Black — as specified');
  }
  steps.push('Final Inspection — In House');
  steps.push('Dispatch to Customer');
  return steps;
}
